(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contest-banner"] && !Shopify.designMode) return;
  try {
    
  /* Compte à rebours jusqu'à la date de fin (réglage de la section) */
  if (!customElements.get('contest-banner')) {
    customElements.define('contest-banner', class extends HTMLElement {
      connectedCallback() {
        const end = new Date(this.dataset.end).getTime();
        this.clock = this.querySelector('[data-countdown]');
        if (!this.clock || Number.isNaN(end)) return;
        const units = Object.fromEntries([...this.clock.querySelectorAll('[data-unit]')].map((el) => [el.dataset.unit, el]));
        const pad = (n) => String(n).padStart(2, '0');
        const tick = () => {
          const left = Math.max(0, end - Date.now());
          const s = Math.floor(left / 1000);
          units.days.textContent = Math.floor(s / 86400);
          units.hours.textContent = pad(Math.floor((s % 86400) / 3600));
          units.minutes.textContent = pad(Math.floor((s % 3600) / 60));
          units.seconds.textContent = pad(s % 60);
          if (left === 0) clearInterval(this.timer);
        };
        tick();
        this.timer = setInterval(tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contest-toast"]) return;
  try {
    
  if (!customElements.get('contest-toast')) {
    customElements.define('contest-toast', class extends HTMLElement {
      connectedCallback() {
        const KEY = 'nadara:contest-closed';
        const end = new Date(this.dataset.end).getTime();
        if (!Number.isNaN(end) && end < Date.now()) return; // jeu terminé
        try {
          const closed = Number(localStorage.getItem(KEY));
          if (closed && Date.now() - closed < 24 * 3600 * 1000) return;
        } catch (e) {}

        const close = () => {
          this.classList.remove('is-open');
          try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
          setTimeout(() => (this.hidden = true), 700);
          clearInterval(this.timer);
        };
        this.querySelector('[data-ctoast-close]').addEventListener('click', close);
        this.addEventListener('keydown', (e) => e.key === 'Escape' && close());

        // Compte à rebours
        const clock = this.querySelector('[data-ctoast-clock]');
        if (clock && !Number.isNaN(end)) {
          const u = Object.fromEntries([...clock.querySelectorAll('[data-unit]')].map((el) => [el.dataset.unit, el]));
          const pad = (n) => String(n).padStart(2, '0');
          const tick = () => {
            const s = Math.max(0, Math.floor((end - Date.now()) / 1000));
            u.days.textContent = Math.floor(s / 86400);
            u.hours.textContent = pad(Math.floor((s % 86400) / 3600));
            u.minutes.textContent = pad(Math.floor((s % 3600) / 60));
            u.seconds.textContent = pad(s % 60);
          };
          tick();
          this.timer = setInterval(tick, 1000);
        } else if (clock) {
          clock.remove();
        }

        // Apparition après le délai, en attendant qu'aucune fenêtre (pop-up de bienvenue, tiroir) ne soit ouverte
        const delay = (Number(this.dataset.delay) || 5) * 1000;
        const show = () => {
          if (document.documentElement.classList.contains('is-locked') || document.querySelector('dialog[open]')) {
            setTimeout(show, 2500);
            return;
          }
          this.hidden = false;
          requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
        };
        setTimeout(show, delay);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-bottles"] && !Shopify.designMode) return;
  try {
    
  /* Parallaxe : chaque élément [data-depth] suit la souris et le défilement selon sa profondeur */
  if (!customElements.get('floating-bottles')) {
    customElements.define('floating-bottles', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.marquee = this.querySelector('[data-marquee]');
        // Montée au défilement : plus douce en ligne, où les flacons restent sur la bande
        this.lift = this.classList.contains('floating--line') ? -12 : -60;
        // En ligne, rotation sur eux-mêmes plus discrète
        this.turn = this.classList.contains('floating--line') ? 0.5 : 1;
        this.layers = [...this.querySelectorAll('[data-depth]')].map((el) => ({ el, depth: parseFloat(el.dataset.depth) || 1 }));
        this.mouse = { x: 0, y: 0 };
        this.current = { x: 0, y: 0 };
        this.scroll = 0;
        this.visible = false;

        this.onMove = (event) => {
          this.mouse.x = event.clientX / window.innerWidth - 0.5;
          this.mouse.y = event.clientY / window.innerHeight - 0.5;
        };
        this.onScroll = () => {
          const rect = this.getBoundingClientRect();
          // -1 quand la section entre par le bas, +1 quand elle sort par le haut
          this.scroll = (window.innerHeight / 2 - (rect.top + rect.height / 2)) / window.innerHeight;
        };

        if (window.matchMedia('(pointer: fine)').matches) window.addEventListener('pointermove', this.onMove, { passive: true });
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();

        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          if (this.visible) this.tick();
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        window.removeEventListener('pointermove', this.onMove);
        window.removeEventListener('scroll', this.onScroll);
        this.observer?.disconnect();
      }

      tick() {
        if (!this.visible) return;
        // Lissage : le mouvement rattrape la souris en douceur
        this.current.x += (this.mouse.x - this.current.x) * 0.06;
        this.current.y += (this.mouse.y - this.current.y) * 0.06;
        // Le grand texte glisse horizontalement au défilement
        if (this.marquee) this.marquee.style.setProperty('--mx', `${(-window.innerWidth * (0.35 + this.scroll * 0.4)).toFixed(1)}px`);
        this.layers.forEach(({ el, depth }, i) => {
          // Un flacon sur deux tourne dans l'autre sens, pour un mouvement plus vivant
          const dir = i % 2 ? -1 : 1;
          const px = this.current.x * depth * -18;
          const py = this.current.y * depth * -14 + this.scroll * depth * this.lift;
          el.style.setProperty('--px', `${px.toFixed(1)}px`);
          el.style.setProperty('--py', `${py.toFixed(1)}px`);
          el.style.setProperty('--spin', `${(this.scroll * depth * 9 * dir).toFixed(2)}deg`);
          // Pivot en 3D : le flacon montre ses côtés selon la souris et le défilement
          el.style.setProperty('--ry', `${((this.current.x * depth * 5 + this.scroll * depth * 5 * dir) * this.turn).toFixed(2)}deg`);
          el.style.setProperty('--rx', `${(this.current.y * depth * -5 + this.scroll * depth * 4).toFixed(2)}deg`);
        });
        requestAnimationFrame(() => this.tick());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
